module.exports = __webpack_public_path__ + "static/media/uploadHeadshot.3cc01f48.png";